import { getSetting } from './indexeddb'

export async function speakAnnouncement(text: string, lang: string) {
  const synth = window.speechSynthesis
  if (!synth) return
  const voices = synth.getVoices()
  const pref = await getSetting('voice')
  const rateSetting = await getSetting('voice_rate')
  const pitchSetting = await getSetting('voice_pitch')
  const v = voices.find(v => v.name === pref) || voices.find(v => v.lang?.startsWith(lang)) || voices.find(v => v.lang?.startsWith('en'))
  if (!v) return
  const utter = new SpeechSynthesisUtterance(text)
  utter.voice = v
  utter.lang = v.lang
  if (rateSetting !== undefined && rateSetting !== null) utter.rate = Number(rateSetting) || 1
  if (pitchSetting !== undefined && pitchSetting !== null) utter.pitch = Number(pitchSetting) || 1
  synth.speak(utter)
}